import { useEffect } from "react";

/**
 * Cursor personalizado animado tipo Agrion (Pixydrops).
 * Dos círculos siguen al mouse con delay distinto:
 *   - Outer (anillo verde grande): sigue con lerp
 *   - Inner (punto amarillo pequeño): sigue instantáneo
 * Se agranda al pasar sobre botones / links / inputs.
 * Solo activo en desktop (>= lg).
 */
export default function CustomCursor() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const outer = document.createElement("div");
    const inner = document.createElement("div");
    outer.className = "ag-cursor-outer";
    inner.className = "ag-cursor-inner";
    document.body.appendChild(outer);
    document.body.appendChild(inner);

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let ox = mx;
    let oy = my;
    let raf;

    const update = () => {
      ox += (mx - ox) * 0.18;
      oy += (my - oy) * 0.18;
      outer.style.transform = `translate3d(${ox}px, ${oy}px, 0) translate(-50%, -50%)`;
      inner.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
      raf = requestAnimationFrame(update);
    };

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
    };

    const onOver = (e) => {
      if (e.target.closest("a, button, input, textarea, select, [data-cursor='hover']")) {
        outer.classList.add("ag-cursor-hover");
      }
    };
    const onOut = (e) => {
      if (e.target.closest("a, button, input, textarea, select, [data-cursor='hover']")) {
        outer.classList.remove("ag-cursor-hover");
      }
    };
    const onDown = () => outer.classList.add("ag-cursor-down");
    const onUp = () => outer.classList.remove("ag-cursor-down");
    const onEnter = () => { outer.style.opacity = "1"; inner.style.opacity = "1"; };
    const onLeave = () => { outer.style.opacity = "0"; inner.style.opacity = "0"; };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver, true);
    document.addEventListener("mouseout", onOut, true);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("mouseup", onUp);
    document.addEventListener("mouseenter", onEnter);
    document.addEventListener("mouseleave", onLeave);

    update();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver, true);
      document.removeEventListener("mouseout", onOut, true);
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("mouseup", onUp);
      document.removeEventListener("mouseenter", onEnter);
      document.removeEventListener("mouseleave", onLeave);
      outer.remove();
      inner.remove();
    };
  }, []);
  return null;
}
